var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('QRCodeDisplay',{attrs:{"qr-code":_vm.qrCodeArgs,"show-download":"true","header":"address_qr_code","download-name":_vm.downloadName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }